
jQuery(document).ready(function($) {

   // Handle variant selection change
  $('[variant-select-list]').change(function() {
    location.href = $(this).find(':selected').data('variant-url');
  });

  // Handle add to cart button click
  $('[add-to-cart]').click(function() {
    // Prevent multiple clicks
    if ($(this).data('processing') === true) {
      return;
    }

    $(this).data('processing', true);
    $(this).find('.fa-circle-notch').remove();
    $(this).append('<i class="fa-solid fa-circle-notch fa-spin"></i>');

    var id = $(this).data('variant-id');
    var quantity = $('[name="quantity"]').val();
    var button = $(this);
    // Safely find the selling_plan input value
    var sellingPlanInput = $('input[name="selling_plan"]');
    var sellingPlan = sellingPlanInput.length > 0 ? sellingPlanInput.val() : null;
    
    addToCart(id, quantity, sellingPlan).then(function() {
      return getCart();
    }).then(function(cart) {
      updateCartCount(cart.item_count);
      button.find('.fa-circle-notch').remove();
      button.data('processing', false);
    }).catch(function(error) {
      alert('Error: ' + error);
      button.find('.fa-circle-notch').remove();
      button.data('processing', false);
    });
  });

  // Function to update the cart count in the header
  function updateCartCount(count) {
    var cartCountHtml = '<div id="cart-count"><span>' + count + '</span></div>';
    $('[header-cart-count]').find('#cart-count').remove();
    $('[header-cart-count]').append(cartCountHtml);
  }

  // Function to get the current cart state
  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .catch((error) => {
      alert('Error: ' + error);
      throw error;
    });
  }

  // Function to add item to the cart
  function addToCart(id, quantity, sellingPlan) {
    let data = {
      'items': [{
        'id': id,
        'quantity': quantity
      }]
    };

   // Include selling_plan if it's provided
  if (sellingPlan) {
    data.items[0].selling_plan = sellingPlan;
  }

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
      if (cart.status === 422) {
        alert(cart.description);
        throw new Error(cart.description);
      }
      return cart;
    })
    .catch((error) => {
      alert('Error: ' + error);
      throw error;
    });
  }

  // Menus    
    $('[open-menu]').click(function() {
        $('body').attr('showing-menu', $(this).attr('open-menu'));
    });

    $('[close-menu]').click(function() {
        $('body').removeAttr('showing-menu');
    });




    //  Checkboxes 
    $('.label-box input[type="checkbox"]').change(function() {
        if ($(this).is(':checked')) {

            $(this).removeAttr('checked')
        } else {
            $(this).attr('checked', 'checked')
        }
    });

    $('.label-box input[type="checkbox"]').change(function() {
        $('#submitButton').prop('disabled', !$(this).is(':checked'));
    });

    $('input[type="checkbox"]').click(function() {
        if ($(this).attr('checked') === 'checked') {
            $(this).removeAttr('checked');
        } else {
            $(this).attr('checked', 'checked');
        }
    });


// Shop Filter, FAQs Accordion

    $(".accordion").on("click", function() {
        $(this).next().toggleClass("active");
        $(this).toggleClass('selected')
        
    });

//Slider on main-product
  
  const $carousel = $('.thumbs');
  const $items = $('.item img');
  const $dotsContainer = $('.nav-dots');

  // Initialize dots
  $dotsContainer.empty();
  $items.each(function(index) {
    $dotsContainer.append('<div class="dot" data-index="' + index + '"></div>');
  });
  const $dots = $('.dot');

  $dots.first().addClass('active');

function updateActiveDot() {
  let currentScroll = $carousel.scrollLeft();
  let itemWidth = $items.width();
  let activeIndex = Math.round(currentScroll / itemWidth);

  $dots.removeClass('active');
  $dots.eq(activeIndex).addClass('active');
}

  $carousel.scroll(updateActiveDot);

  // Handle dot click event
  $dots.on('click', function() {
    let index = $(this).data('index');
    let itemWidth = $carousel.width();
    $carousel.animate({scrollLeft: itemWidth * index}, 300);
  });

  // Handle thumb click event on shop-single

    // Set the first image OR variant image if available
    var variantId = new URLSearchParams(window.location.search).get("variant");
    var matchedVariant = window.ProductData?.variants.find(v => v.id == variantId);
    
    var initialSrc = matchedVariant && matchedVariant.image
      ? (matchedVariant.image.startsWith("http") ? matchedVariant.image : `https:${matchedVariant.image}`)
      : $(".thumbs .item img").first().attr("src");
    
    $(".main-view img").attr("src", initialSrc).css("left", "0");

    // Attach click events to thumbnails for sliding effect
    $(".thumbs .item img").click(function() {
        var newSrc = $(this).attr("src");
        var $currentImg = $(".main-view img");
        var $newImg = $("<img>").attr("src", newSrc).css("left", "100%").appendTo(".main-view"); 

        $currentImg.animate({left: "-100%"}, 600); 
        $newImg.animate({left: "0"}, 600, function() {
            $currentImg.remove();
        });
    });

    // Attach click event for the angle-down icon for sliding to the next image
    $(".fa-angle-down").click(function() {
        var $currentImg = $(".main-view img");
        var thumbs = $(".thumbs .item img");
        var currentIndex = thumbs.index(thumbs.filter(function() {
            return $(this).attr("src") === $currentImg.attr("src");
        }));
        var nextIndex = (currentIndex + 1) % thumbs.length;
        var newSrc = thumbs.eq(nextIndex).attr("src");
        var $newImg = $("<img>").attr("src", newSrc).css("left", "100%").appendTo(".main-view");

        $currentImg.animate({left: "-100%"}, 600); 
        $newImg.animate({left: "0"}, 600, function() {
            $currentImg.remove();
        });
    });



  // Update dots on resize to maintain alignment with items
  $(window).resize(updateActiveDot);
    

  // Showing product details on quick view click

$(function() {
    $('.tag').click(function(event) {
      event.stopPropagation(); 
      $(this).parent().attr('data-details', true);
    });
  
    $(document).click(function(event) {
      if ($(event.target).closest('.prod-card a').length === 0) {
        $('.prod-card').attr('data-details', false);
      }
    });
  });

  // Testimonial Cards Randomizer

  const testimonial = [
    {
      comment: "I have had an excellent experience with Bio-Tech for many reasons. 1) Their products are outstanding. My pain doctor recommended that I take Vitamin D and suggested Bio-Tech. I was extremely low on Vitamin D and after  3-4 months of using Bio-techs D3 my levels were back on track. 2) Their customer service is outstanding. I can't say enough good things about this company. I will continue order all my items from this company! You will not be disappointed.",
      reviewer: "Robin M."
    },
    {
      comment: "After taking the vitamins, my liver numbers have been great and my doctor drastically lowered my medication. I will definitely continue to buy from this company.",
      reviewer: "Joseph P."
    },
    {
      comment: "My doctor checks my Vitamin D level annually and the weekly capsule keeps me at a good level.",
      reviewer: "Avery K."
    },
    {
      comment: "I have always had very low Vitamin D levels despite taking supplements. A friend recommended Bio Tech’s Vitamin D. Said it was the only one that had helped her. I tried it and, for the first time, my levels were in the normal range. Have been taking it for years, and my levels have stayed high. Wonderful!!!",
      reviewer: "Julia P."
    },
    {
      comment: "Per our doctor’s advice and routine bloodwork for over a decade, my wife takess 100,000 weekly and I take 50,000. It’s nice to accomplish in just one or two pills a week versus a couple daily. The quality of this brand is uniformly high, the price is very competitive, and shipping is quick.",
      reviewer: "Chris W."
    },
    {
      comment: "I’ve been a gastric bypass/duodenal switch patient since 2003. I do not absorb fat soluble vitamins. The BioTech vitamins have been the only ones that keep my levels normal. Especially their formula for vitamin D. It has prevented my parathyroid from pulling calcium from my bones thereby decreasing the very real risk of osteoporosis. I highly recommend BioTech vitamins.",
      reviewer: "Irene S."
    },
    {
      comment: "Great Products!  Great Service! Delivered Quick! Thanks",
      reviewer: "Ronald D."
    },
    {
      comment: "Fast, accurate and easy to deal with.  My physician recommended their products to me and they seem to work great!",
      reviewer: "Jerry G."
    },
    {
      comment: "I use this company, because the vitamins are real.  I had a gastric bypass surgery in 2007 and this company has kept my levels on track.",
      reviewer: "Patsy M."
    },
    {
      comment: "I’ve been using these vitamins for more than 10 years and I swear by them. I’ve tried others and I haven’t found any thing close to as good as these. I’m an especially big fan or their iron and D vitamins. And the customer service is excellent.",
      reviewer: "Ilana P."
    },
    {
      comment: "Bio-Tech makes great supplements in the high doses I need. Ordering from them was quick and easy.",
      reviewer: "Amanda H."
    },
    {
      comment: "I have used Bio Tech Pharmacals for many years with confidence. I still haven't received the last order and it has been several weeks. The Post Office cannot find the last order. I will however, need to reorder because it was probably my fault.. I may have given an incomplete address.",
      reviewer: "J. Wolf"
    },
    {
      comment: "My endocrinologist is the one who told me about Bio-Tech for my vitamin D supplement! After the prescribed right dose of vitamin D from the doctor and great supplement my levels are finally up. Thanks Bio-Tech for quality product!",
      reviewer: "Julie M."
    },
    {
      comment: "I appreciate Bio-Tech's ethos. They make great products that you can trust, they are transparent, and their service is fast.",
      reviewer: "Bethany B."
    },
    {
      comment: "Fast order fulfillment, beautifully packaged, great product. Water-soluble D3 in 50,000iu dosage is a beautiful solution to low D3 levels, critical now we know its role in immune function.",
      reviewer: "Scott M."
    },
    {
      comment: "I have genetic mutations which don’t allow me to process fat properly and I’ve had a chronic vitamin D deficiency while trying to treat with normal fat soluble vitamins which never worked. I have been on Bio-Tech Pharmacal D3-5 5,000 IU (Vitamin D3) since the beginning of the year (2021) and finally have sufficient Vitamin D levels for the first time in over a decade. My PCP now has this brand as a recommendation for patients who struggle with normal Vit D therapies to see if it will help them too.  I will never switch brands!",
      reviewer: "Gina C."
    },
    {
      comment: "It came to me recommended by the Grassrootshealth researchers and I will not buy any other product since taking their VItamin D plus K2. I personally need the 10,000 IU D formula to keep my D levels at peak. BUT they are also the only company I have found who include the D & K together is the proper quantities ana a great small capsule! Congratulations, and thanks.",
      reviewer: "Alice S."
    },
    {
      comment: "I've always been skeptical of the supplement industry but decided to give this company a chance as my doctor recommended them to me. I've been taking their vitamin d3 5000iu and verified through a blood test that they are indeed a high quality supplement. I will look into their other vitamins and also recommend them to friends.",
      reviewer: "Jesse L."
    },
    {
      comment: "I have been ordering my vitamin D3 from Bio-Tech Pharmacal Inc for a long time. I have been very satisfied with this product & will continue to do so whenever I need more!",
      reviewer: "Marcia K."
    },
    {
      comment: "I had a great experience ordering from Bio-Tech.  They did a great job getting me my vitamins at a great price and it a timely manner. Will definitely order from them in the future.",
      reviewer: "Clayton R."
    },
    {
      comment: "Bio-Tech is my number 1 choice to purchase Vitamin D3 50. Years ago it was the only place I could find 50k IU. Now I stay for the excellent customer service, reliabilty & speedy shipping!! Thank you Bio-Tech!",
      reviewer: "Melissa"
    },
    {
      comment: "We have always been satisfied with the service we receive from Bio-Tech. We are grateful for the quality of the products and the timeliness of delivery. We will be back. Thank you.",
      reviewer: "Dr. Wayne S."
    },
    {
      comment: "These pills were suggested from my doctor several years ago and my Vitamin D numbers never looked so good.",
      reviewer: "Christy H."
    }
  ]

  
for ( let i = 0; i < 4; i++ ) {
  let randomIndex = Math.floor(Math.random() * testimonial.length);
  let selected_testimonial = testimonial[randomIndex];
  
  const maxLength = 180;
  let truncatedComment = selected_testimonial.comment;
  if (truncatedComment.length > maxLength) {
    truncatedComment = `${truncatedComment.slice(0, maxLength)}... <span class="read-more">Read More</span>` ;
  }

  $('.testimonials .card' ).eq(i).html(`
  <p class="italic truncated" data-full-comment="${selected_testimonial.comment}">${truncatedComment}</p>
  <br>
  <p class="text-blue">- ${selected_testimonial.reviewer}</p>`)
  
  testimonial.splice(randomIndex, 1);

};
  // Expand testimonial card text
$(document).on('click', '.card .truncated', function() {
  const $truncatedElement = $(this);
  const fullComment = $truncatedElement.data('full-comment');
  console.log('click')
  $truncatedElement.text(fullComment);
});

  

  
});
